import React, { Component } from "react";
import { Card, CardBody, Progress } from "reactstrap";
import moment from "moment";
import NotificationSystem from "react-notification-system";
import AuditPanel from "./audit-panel";
import { apiActions, alertActions, commonActions } from "../../_actions";
import { appConstants } from "../../_constants";
import { appHelpers, store } from "../../_helpers";
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";
import { connect } from "react-redux";
import { commonService } from "../../_services";
import ViewHeader from "./view-header";
import AuditTrailRecords from "./audit-table";

const ViewContent = ({ children }) => (
    <div className="view-content view-components">{children}</div>
);



class AuditTrails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startDate: new Date(),
            endDate: new Date(),
            UserId: null,
            auditActions: [],
            auditAction: "",
            users: [],
            userName: "",
            //page error
            contentError: false, //Errors that affect content on the page
            componentError: false, //Errors generated within the component
            componentErrorMessages: [],
            error: false, //Error state mutable via Redux
            success: false, //Success message mutable via Redux
            //Notification
            notification: {
                // title: 'Default Title',
                message: "Default Message",
                level: "success",
                position: "tr",
                dismissible: true
            },
            records: null,
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            selectedAction: ""
        };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }



    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        const reduxState = store.getState();
        let { authentication} = reduxState;

        if (authentication) {
            if (authentication.user !== undefined) {
                this.setState({
                    UserId: authentication.user.userId
                });
            }
        }
       
        this.fetchOrgUsers();
        this.getAuditActions();
    }

    notify = (message, level) => {
        let notification = this.state.notification;
        notification["message"] = message;
        notification["level"] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(
            notification
        );
    };

    getAuditActions = () => {
        const { dispatch } = this.props;
        this.setState({ contentError: false });
        dispatch(apiActions.startRequest());

        commonService.getAuditActions().then((res) => {
            dispatch(apiActions.endRequest());
            let response = res.response;
            if (res.status === appConstants.SUCCESS_RESPONSE) {
                this.setState({ auditActions: this.formatData(response) })
            } else if (res.status === appConstants.ERROR_RESPONSE) {
                if (response === "Please Check your internet connectivity") {
                    dispatch(alertActions.error(response));
                }
            }
        });
    };

    
    fetchOrgUsers = () => {
        this.setState({ contentError: false });
        const { dispatch } = this.props;
        dispatch(commonActions.getUsersByOrganization())
            .then(() => {
                let { users } = this.props;
                users.ResultList.map(item => item.Name = `${item.FirstName}  ${item.LastName}`);
                this.setState({ users: this.formatData(users.ResultList) });
            }).catch(error => {
                let errorMessage = appHelpers.interpretErrorResponse(error);
                this.notify(errorMessage, appConstants.NOTIFY_ERROR);
                this.setState({ contentError: errorMessage });
            });
    };

    formatData(data) {
        const res = data.map(item => ({
            value: item.Id,
            label: item.Name
        }));

        return res;
    }

    getAuditTrail = (pageNumber = 1) => {
        const { dispatch } = this.props;
        const { endDate, auditAction, startDate, pageSize, userName } = this.state;
        dispatch(apiActions.startRequest());
        const payload__ = {
            size: pageSize,
            from: pageNumber,

            startdate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
            enddate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59",
            UserId: userName.value,
            AuditActionId: auditAction.value

        };
        commonService
            .getAuditTrail(payload__)
            .then(res => {
                let response = res.response;
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    this.setState({
                        currentPage: pageNumber === 0 ? 1 : pageNumber,
                        records: response.data.AuditTrailResponse,
                        totalCount: response.data.TotalCount
                    });
                    dispatch(apiActions.endRequest());
                } else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(
                        alertActions.error(
                            appHelpers.interpretErrorResponseAlt2(res.response)
                        )
                    );
                    dispatch(apiActions.endRequest());
                }
            })
            .catch(err => {
                dispatch(
                    alertActions.error(appHelpers.interpretErrorResponseAlt2(err))
                );
                dispatch(apiActions.endRequest());
            });

    };


    handleSelectChange = auditAction => {
        this.setState({ auditAction: auditAction });
        if (auditAction === null) {
            this.setState({ auditAction: "" })
        }
    };

    handleUserChange = userName => {
        this.setState({ userName: userName });
        if (userName === null) {
            this.setState({ userName: "" })
        }
    };

    interpretUserId = (userId) => {
        const { users } = this.state;
        let check = users.find(user => user.value === userId);
        if (check) {
            return check.label;
        } else {
            return `Unknown User`;
        }
    };


    handleDateChange = (date, target) => {
        this.setState({ [target]: date });
    };

    render() {
        const { requesting, pageRequesting } = this.props;
        const { auditActions, componentErrorMessages, userName, users,
            contentError, records, totalCount, auditAction,
            currentPage, pageSize } = this.state;
        return (
            <div className="view">
                <ViewHeader />
                <ViewContent>
                    <Card className="mb-4">
                        {(pageRequesting || requesting) &&
                            !pageRequesting && (
                                <Progress
                                    striped
                                    animated
                                    color="success"
                                    value={100}
                                    className="mb-2"
                                />
                            )}
                        {/*Display loader when component content is dependent on Data from API*/}
                        {!contentError && pageRequesting && <PageLoading />}

                        {/*Display error when component fail to get Data from API*/}
                        {contentError && <PageError error={this.state.contentError} />}


                        {/*Display component content when Data is gotten from API*/}
                        {!contentError &&
                            !pageRequesting && (
                                <CardBody>
                                    <h6 className="mb-0 text-uppercase pull-left">
                                        View Audit Trail
                                  </h6>
                                    <div className="clearfis">&nbsp;</div>
                                    <AuditPanel
                                        handleDateChange={this.handleDateChange}
                                        handleEndDateChange={this.handleDateChange}
                                        handleSelectChange={this.handleSelectChange}
                                        handleUserChange={this.handleUserChange}
                                        componentErrorMessages={componentErrorMessages}
                                        actions={auditActions}
                                        selectedAction={auditAction}
                                        users={users}
                                        selectedName={userName}
                                        requesting={requesting}
                                        onSearch={this.getAuditTrail}
                                    />
                                    <CardBody>
                                        {!pageRequesting && records && (
                                            <div>
                                                <AuditTrailRecords
                                                    records={records}
                                                    currentPage={currentPage}
                                                    pageDataCallback={this.getAuditTrail}
                                                    pageSize={pageSize}
                                                    totalCount={totalCount}
                                                    interpretUserId={this.interpretUserId}
                                                />
                                            </div>
                                        )}
                                        {!pageRequesting && !records && (
                                            <PageEmptyContent message="No record match your search!" />
                                        )}
                                    </CardBody>
                                </CardBody>
                            )}
                        <NotificationSystem ref="notificationSystem" />
                    </Card>
                </ViewContent>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { loggingIn } = state.authentication;
    const { pageRequesting, requesting } = state.api;
    const { alert, manifestReports, users, airlinesCarriers } = state;
    return {
        loggingIn,
        requesting,
        pageRequesting,
        alert,
        manifestReports,
        airlinesCarriers,
        users
    };
}

export default connect(mapStateToProps)(AuditTrails);


// WEBPACK FOOTER //
// ./src/views/audit-trail/index.js